import { TwinDictionary } from '../../../globals/dictionary'
import useTwinTranslation from '../../useTwinTranslation'


const useSellStatsColumns = () => {
    const { t } = useTwinTranslation()
    const translations: TwinDictionary = {
        'creatingN': t('creatingN', 'Cantidad en borrador'),
        'creatingPercentatge': t('creatingPercentatgeInQuantity', 'Porcentaje en borrador (cantidad)'),
        'creatingAmount': t('creatingAmount', 'Importe en borrador'),
        'creatingPercentatgeAmount': t('creatingPercentatgeInAmount', 'Porcentaje en borrador (importe)'),
        'canceledN': t('canceledN', 'Cantidad en cancelados'),
        'canceledPercentatge': t('canceledPercentatgeInQuantity', 'Porcentaje en cancelados (cantidad)'),
        'canceledAmount': t('canceledAmount', 'Importe en cancelados'),
        'canceledPercentatgeAmount': t('canceledPercentatgeInAmount', 'Porcentaje en cancelados (importe)'),
        'waitingResponseN': t('waitingResponseN', 'Cantidad esperando respuesta'),
        'waitingResponsePercentatge': t('waitingResponsePercentatgeInQuantity', 'Porcentaje en espera (cantidad)'),
        'waitingResponseAmount': t('waitingResponseAmount', 'Importe en espera'),
        'waitingResponsePercentatgeAmount': t('waitingResponsePercentatgeInAmount', 'Porcentaje en espera (importe)'),
        'savedN': t('savedN', 'Cantidad de reservados'),
        'savedPercentatge': t('savedPercentatgeInQuantity', 'Porcentaje de reservados (cantidad)'),
        'savedAmount': t('savedAmount', 'Importe en reservados'),
        'savedPercentatgeAmount': t('savedPercentatgeInAmount', 'Porcentaje de reservados (importe)'),
        'sentN': t('sentN', 'Cantidad de reservados'),
        'sentPercentatge': t('sentPercentatgeInQuantity', 'Porcentaje de enviados (cantidad)'),
        'sentAmount': t('sentAmount', 'Importe en enviados'),
        'sentPercentatgeAmount': t('sentPercentatgeInAmount', 'Porcentaje de enviados (importe)'),
        'refundedN': t('refundedN', 'Cantidad de devoluciones'),
        'refundedPercentatge': t('refundedPercentatgeInQuantity', 'Porcentaje de devoluciones (cantidad)'),
        'refundedAmount': t('refundedAmount', 'Importe en devoluciones'),
        'refundedPercentatgeAmount': t('refundedPercentatgeInAmount', 'Porcentaje de devoluciones (importe)'),
        'acceptedN': t('acceptedN', 'Cantidad de aceptados'),
        'acceptedPercentatge': t('acceptedPercentatgeInQuantity', 'Porcentaje de aceptados (cantidad)'),
        'acceptedAmount': t('acceptedAmount', 'Importe en aceptados'),
        'acceptedPercentatgeAmount': t('acceptedPercentatgeInAmount', 'Porcentaje de aceptados (importe)'),
        'deniedN': t('deniedN', 'Cantidad de rechazados'),
        'deniedPercentatge': t('deniedPercentatgeInQuantity', 'Porcentaje de rechazados (cantidad)'),
        'deniedAmount': t('deniedAmount', 'Importe en rechazados'),
        'deniedPercentatgeAmount': t('deniedPercentatgeInAmount', 'Porcentaje de rechazados (importe)'),
        'totalN': t('totalQuantity', 'Cantidad total'),
        'totalPercentatge': t('totalPercentatgeInQuantity', 'Porcentaje total (cantidad)'),
        'totalAmount': t('totalAmount', 'Importe total'),
        'totalFacturationPercentatge': t('totalFacturationPercentatgeInAmount', 'Porcentaje total (importe)'),
    }

    return translations
}

export const useSellStatsColumnsShort = () => {
    const { t } = useTwinTranslation()
    const translations: TwinDictionary = {
        'creatingAmount': t('inDraft', 'En borrador'),
        'canceledAmount': t('inCanceled', 'En cancelados'),
        'waitingResponseAmount': t('inWaitingResponse', 'En esperando resp.'),
        'savedAmount': t('inReserved', 'En reservados'),
        'sentAmount': t('inSent', 'En enviados'),
        'refundedAmount': t('inRefunds', 'En devoluciones'),
        'acceptedAmount': t('inAccepted', 'En aceptados'),
        'deniedAmount': t('inDenied', 'En rechazados'),
        'totalAmount': t('inTotal', 'En total'),
    }

    return translations
}

export default useSellStatsColumns